













import { Vue, Component } from 'vue-property-decorator'
import LinksStore from '../components/LinksStore.vue'

@Component({
  components: {
    LinksStore,
  }
})

export default class FooterApp extends Vue {
  links = [
    { img: '/static/images/google-play.png', link: 'https://play.google.com/store/apps/details?id=com.wildberries.portal&hl=ru' },
    { img: '/static/images/app-store.png', link: 'https://apps.apple.com/ru/app/wb-%D0%BF%D0%B0%D1%80%D1%82%D0%BD%D1%91%D1%80%D1%8B/id1466739454' },
  ]
}
